import api from "@/lib/api";

const CHUNK = 5 * 1024 * 1024;

// Uploads a file in 5 MB pieces so large videos pass the proxy limits.
export async function uploadChunked(url, file, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const id = Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => b.toString(16).padStart(2, "0")).join("");
  let res;
  for (let i = 0; i < total; i += 1) {
    const fd = new FormData();
    fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    fd.append("upload_id", id);
    fd.append("index", i);
    fd.append("total", total);
    fd.append("filename", file.name);
    res = await api.post(url, fd);
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return res;
}
